import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-spinner',
  templateUrl: './member-spinner.component.html',
  styleUrls: ['./member-spinner.component.scss']
})
export class MemberSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
